var _path, _g, _circle, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 258,
    viewBox: "0 0 370 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.34 235.976C112.256 221.114 3.81887 179.273 16.5363 99.621C29.1305 20.741 145.6 18.067 237.782 32.7851C306.514 43.7589 363.256 94.667 353.866 153.48C344.311 213.324 275.277 247.142 205.34 235.976Z",
    fill: "#E2EBEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.528 218.992H154.528V121.272L230.525 60.9922L306.528 121.272V218.992Z",
    fill: "#CDDEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8628 40.1709H256.78V153.148C256.78 164.128 252.404 174.658 244.614 182.422C236.824 190.186 226.258 194.549 215.24 194.549H97.8628V40.1709Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M256.826 245.898C256.826 245.898 243.842 236.677 238.418 228.364C224.281 206.705 216.596 195.604 216.596 191.392C216.596 188.944 220.006 175.762 220.552 173.313C220.655 172.831 220.816 172.364 221.033 171.922L217.499 168.783C217.304 168.6 217.181 168.354 217.151 168.089C217.181 168.354 217.304 168.6 217.499 168.783C214.909 166.487 212.249 160.879 211.019 158.075C211.781 161.048 213.505 166.983 215.684 169.638L217.967 172.442C217.035 172.714 216.252 173.483 215.85 175.3C215.303 177.752 211.877 190.938 211.877 193.395C211.877 197.611 219.562 208.712 233.699 230.371C237.585 236.326 245.354 242.76 249.443 245.91L256.826 245.898Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.929 200.522L232.145 189.488C232.145 189.488 229.551 178.206 229.141 175.217C228.731 172.227 225.052 170.323 223.689 170.323C222.325 170.323 221.095 170.868 220.552 173.313C220.009 175.758 216.595 188.943 216.595 191.392C216.595 195.604 224.281 206.704 238.418 228.364C243.841 236.677 256.826 245.898 256.826 245.898H295.984L295.155 244.106C293.284 240.003 292.489 235.495 292.843 231.003L295.487 197.359C295.651 195.262 295.28 193.158 294.406 191.243C293.532 189.328 292.184 187.666 290.49 186.412L281.259 179.577L271.804 163.121C270.626 161.07 268.856 159.42 266.724 158.384C264.592 157.349 262.197 156.976 259.851 157.315V157.348C258.229 156.441 256.42 155.918 254.564 155.82C252.707 155.722 250.853 156.051 249.145 156.782L230.106 164.901C229.66 165.092 229.26 165.377 228.936 165.738C228.611 166.098 228.369 166.525 228.227 166.988C228.084 167.451 228.045 167.939 228.111 168.419C228.178 168.899 228.348 169.358 228.611 169.766C229.076 170.486 229.801 171.001 230.637 171.203C233.468 171.883 236.405 172.005 239.284 171.562L253.884 169.307L259.109 186.329L258.392 195.299L250.934 198.664C247.094 201.059 243.054 201.212 240.929 200.522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.38 185.813C241.08 185.998 240.789 186.198 240.51 186.412C238.383 188.06 235.688 188.802 233.015 188.476L231.879 188.336C232.041 189.059 232.144 189.492 232.144 189.492L237.564 196.285L242.424 185.165L241.38 185.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.148 180.47L231.88 188.316L233.015 188.456C235.689 188.782 238.383 188.04 240.51 186.391C240.79 186.177 241.08 185.977 241.38 185.793L251.324 179.631L258.152 183.166L253.901 169.283L242.42 171.096L230.148 180.47Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M253.896 169.303L242.42 171.095L239.068 173.66C243.558 174.486 248.156 174.558 252.67 173.87L253.499 180.796L258.16 183.207L253.896 169.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M230.148 180.466L230.844 183.616L236.184 188.357C237.761 188.058 239.243 187.39 240.51 186.408C240.79 186.194 241.08 185.994 241.38 185.809L243.945 184.219L235.281 176.534L230.148 180.466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M242.283 185.483L242.308 185.239L241.38 185.813C241.08 185.998 240.789 186.198 240.51 186.412C238.383 188.06 235.688 188.803 233.015 188.477L231.879 188.336C232.041 189.059 232.144 189.493 232.144 189.493L234.042 191.875C235.839 191.779 237.641 191.837 239.428 192.049L242.283 185.483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.928 200.523C243.054 201.212 247.093 201.06 250.93 198.665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.671 189.286L264.524 162.031C263.068 159.411 260.689 157.423 257.846 156.452C255.004 155.482 251.901 155.598 249.14 156.778L230.106 164.901C229.659 165.092 229.26 165.377 228.935 165.738C228.611 166.098 228.369 166.525 228.226 166.988C228.084 167.451 228.044 167.939 228.111 168.419C228.177 168.899 228.347 169.358 228.61 169.766V169.766C229.075 170.486 229.801 171.001 230.636 171.203C233.467 171.883 236.405 172.005 239.283 171.562L253.884 169.307L259.108 186.329L258.392 195.298",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.863 157.315C262.21 156.976 264.604 157.349 266.736 158.384C268.868 159.42 270.638 161.07 271.816 163.121L287.56 190.508",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.271 179.578L290.502 186.412C292.197 187.666 293.544 189.328 294.418 191.243C295.292 193.158 295.664 195.262 295.499 197.359L292.856 231.003C292.497 235.494 293.289 240.002 295.155 244.106L295.984 245.898",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42 171.075L230.152 180.466",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.053 178.475L258.152 183.187",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.879 188.332L233.015 188.473C235.688 188.799 238.383 188.056 240.51 186.408V186.408C240.789 186.194 241.08 185.994 241.38 185.809L251.323 179.648",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56 196.285L242.42 185.165",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.463 57.6733H200.598V78.4697H221.463V57.6733Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.696 68.5799L208.474 72.3461L217.714 63.1372",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.804 68.0718H115.811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.463 99.6504H200.598V120.447H221.463V99.6504Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.696 110.556L208.474 114.327L217.714 105.118",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.804 110.053H115.811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.329 171.657C166.562 160.648 177.131 132.034 166.355 132.034C153.262 132.034 152.649 162.518 169.015 162.345C184.56 162.184 191.309 148.482 183.396 148.482C178.602 148.482 175.424 160.871 183.744 160.871C192.063 160.871 198.618 156.799 210.633 156.799",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07 224.099C287.587 222.401 288.157 220.439 287.344 219.717C286.53 218.995 284.641 219.786 283.124 221.485C281.607 223.183 281.037 225.145 281.85 225.867C282.664 226.589 284.553 225.797 286.07 224.099Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.271 223.39C285.966 222.612 286.228 221.713 285.855 221.382C285.483 221.052 284.617 221.415 283.922 222.193C283.226 222.971 282.964 223.871 283.337 224.201C283.71 224.532 284.575 224.169 285.271 223.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.775 164.389C220.291 162.692 222.18 161.911 222.992 162.622C220.129 160.082 213.546 157.563 211.184 156.712C211.11 156.689 211.031 156.687 210.956 156.706C210.881 156.725 210.813 156.765 210.759 156.821C210.706 156.877 210.669 156.947 210.653 157.022C210.638 157.098 210.644 157.176 210.67 157.249C211.661 159.599 214.627 166.222 217.499 168.77C216.686 168.048 217.262 166.086 218.775 164.389Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.67 157.249C211.035 158.116 211.669 159.566 212.468 161.176C212.468 161.176 214.014 160.805 214.32 159.937C214.627 159.07 214.876 158.699 216.172 158.699C214.138 157.798 212.24 157.084 211.201 156.704C211.125 156.675 211.042 156.669 210.963 156.686C210.884 156.704 210.811 156.744 210.755 156.802C210.698 156.86 210.66 156.934 210.645 157.013C210.63 157.092 210.639 157.175 210.67 157.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.992 162.622C222.163 161.903 220.291 162.692 218.774 164.389C217.258 166.086 216.703 168.048 217.498 168.77L221.032 171.909C221.259 171.405 221.635 170.983 222.11 170.699C222.585 170.416 223.136 170.284 223.688 170.323C225.051 170.323 228.735 172.227 229.141 175.217C229.269 176.158 229.617 177.917 230.027 179.887L281.851 225.882C281.022 225.159 281.61 223.198 283.127 221.501C284.643 219.803 286.533 219.023 287.345 219.733L222.992 162.622Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.878 204.223L232.145 189.488C232.145 189.488 229.551 178.207 229.141 175.217C228.731 172.227 225.052 170.323 223.689 170.323C222.325 170.323 221.095 170.868 220.552 173.313C220.009 175.758 216.595 188.943 216.595 191.392C216.595 195.604 224.281 206.704 238.418 228.364C243.841 236.677 256.826 245.898 256.826 245.898",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M279.672 189.286L264.686 157.613C263.124 157.187 261.491 157.084 259.888 157.311C261.84 158.431 263.444 160.066 264.524 162.035L279.672 189.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M285.684 182.844L281.271 179.578L287.548 190.509L285.684 182.844Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0004,
    cy: 46.9922,
    r: 32,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7629 55.9922V41.5882L55.7729 42.2902V39.7422L60.1669 37.7922H62.2209V55.9922H58.7629Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.796,
    height: 201.931,
    fill: "white",
    transform: "translate(99.5277 41.7988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/Apply.403361700e597eb0910c65f92aab339d.svg";
export { ForwardRef as ReactComponent };